import { useCallback, useContext } from 'react';
import { useBookmarkItems } from '../general/bookmark-selection';
import { useApi } from '../providers/api-provider';
import { ContentPage } from '../components/content-page';
import { UserDirectory } from '../components/admin-users/user-directory';
import { UserDto } from '../general/dtos';
import UserManagementPage from '../components/admin-users/user-management';
import { UserManagementDataContext, UserManagementDataProvider } from '../providers/user-management-provider';
import { SelectedDetailsHeading } from '../components/selected-details-heading';
import { useLocation } from 'react-router-dom';

export default function AdminUsersPage() {
    const { search } = useLocation();
    const api = useApi();
    const loadUser = useCallback((key: string) => api!.getUser(key), [api]);
    const { items: selectedUsers, setItems: setSelectedUsers, error } = useBookmarkItems<UserDto>('user', api ? loadUser : null, userKey);
    
    return (
        <UserManagementDataProvider>
            {error && <p role="alert">{error}</p>}
            <div style={{ flex: 1, display: 'flex', minHeight: 0, width: '100%', minWidth: '0'/*, backgroundColor: 'blue'*/ }}>
                <ContentPage
                    pageId="users"
                    pageTitle="User management"
                    leftPanelTitle="Users"
                    rightPanelTitle="Selected user(s) details"
                    rightPanelHeading={<UserDetailsHeading users={selectedUsers} />}
                    mobileTabs
                    mobileBackLabel="Back to users"
                    mobileRightPanelTitle="Details"
                    initialMobilePanel={new URLSearchParams(search).has('user') ? 'right' : 'left'}
                    leftContent={<UserDirectory selectedUsers={selectedUsers} onSelectionChange={setSelectedUsers} />}
                    rightContent={<UserManagementPage selectedUsers={selectedUsers} />}
                />
            </div>
        </UserManagementDataProvider>
        );
}

const userKey = (user: UserDto) => user.sub;

function UserDetailsHeading({ users }: { users: UserDto[] }) {
    const ctx = useContext(UserManagementDataContext)!;
    const names = users.map(user => {
        const current = users.length === 1 && ctx.mode === 'edit' && ctx.selectedUser?.sub === user.sub ? ctx.selectedUser : user;
        return [current.first_name, current.last_name].filter(Boolean).join(' ').trim() || current.email || current.sub;
    });
    return <SelectedDetailsHeading label="User details" names={names} />;
}
